import {
  CREATE_QR_DESIGN_REQUEST,
  CREATE_QR_DESIGN_SUCCESS,
  CREATE_QR_DESIGN_FAIL,
  GET_QR_DESIGNS_REQUEST,
  GET_QR_DESIGNS_SUCCESS,
  GET_QR_DESIGNS_FAIL,
} from "../actionTypes";

const initialState = {
  qr_designs: [],
  loading: false,
  error: null,
  count: 0,
  creating: false,
  createError: null,
};

export const qrDesignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QR_DESIGNS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_QR_DESIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        qr_designs: action.payload.qr_designs || action.payload.data || [],
        count: action.payload.count || 0,
      };
    case GET_QR_DESIGNS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        qr_designs: [],
        count: 0,
      };
    case CREATE_QR_DESIGN_REQUEST:
      return {
        ...state,
        creating: true,
        createError: null,
      };
    case CREATE_QR_DESIGN_SUCCESS:
      return {
        ...state,
        creating: false,
        createError: null,
        qr_designs: [action.payload.data, ...state.qr_designs],
        count: state.count + 1,
      };
    case CREATE_QR_DESIGN_FAIL:
      return {
        ...state,
        creating: false,
        createError: action.payload,
      };
    default:
      return state;
  }
};

